import { fmtBRL } from "@/lib/api";
import { CheckCircle, Trash, Warning, ArrowUUpLeft, PencilSimple } from "@phosphor-icons/react";
import { MONTH_NAMES, METHOD_LABELS, METHOD_COLORS, iso } from "@/components/finance/apShared";

export default function BillsTable({ bills, sortedBills, cursor, onPay, onUnpay, onEdit, onDelete }) {
  const todayIso = iso(new Date());
  return (
    <div className="mt-6 border border-black bg-white" data-testid="bills-list">
      <div className="border-b border-black p-4 flex items-center justify-between">
        <div>
          <div className="overline text-zinc-500">TODAS AS CONTAS · {MONTH_NAMES[cursor.getMonth()].toUpperCase()} {cursor.getFullYear()}</div>
          <div className="font-head text-xl font-bold">{bills.length} lançamento{bills.length !== 1 ? "s" : ""}</div>
        </div>
      </div>
      <table className="table">
        <thead><tr><th>Vencimento</th><th>Fornecedor</th><th>Descrição</th><th>Forma</th><th className="text-right">Valor</th><th>Status</th><th>Pago em</th><th className="text-right">Ações</th></tr></thead>
        <tbody>
          {bills.length === 0 && <tr><td colSpan={8} className="text-center py-10 text-zinc-400">Nenhuma conta cadastrada neste mês.</td></tr>}
          {sortedBills.map((b) => (
            <tr key={b.id} data-testid={`bill-row-${b.id}`} className={b.status === "paid" ? "bg-[#F1F8F1]" : ""}>
              <td className="font-mono text-xs">{new Date(b.due_date + "T12:00:00").toLocaleDateString("pt-BR")}</td>
              <td className="font-semibold">{b.supplier_name || "—"}</td>
              <td className="text-sm text-zinc-600">{b.description || "—"}{b.parent_bill_id && <span className="ml-2 text-[9px] px-1 py-0.5 bg-yellow-100 border border-yellow-400 uppercase font-bold tracking-widest">RECORRENTE</span>}</td>
              <td><span className="text-xs px-2 py-0.5 border" style={{ borderColor: METHOD_COLORS[b.payment_method], color: METHOD_COLORS[b.payment_method] }}>{METHOD_LABELS[b.payment_method] || b.payment_method}</span></td>
              <td className="text-right font-mono font-bold">{fmtBRL(b.amount)}</td>
              <td data-testid={`bill-status-${b.id}`}>
                {b.status === "paid" ? (
                  <span className="text-xs px-2 py-1 bg-[#00A300] text-white font-bold uppercase tracking-widest">
                    <CheckCircle size={11} weight="fill" className="inline mr-1" />PAGO
                  </span>
                ) : (
                  <span className={`text-xs px-2 py-1 ${b.due_date < todayIso ? "bg-red-100 text-[#E60000] font-bold" : "bg-yellow-100 text-black"}`}>
                    {b.due_date < todayIso && <Warning size={11} weight="fill" className="inline mr-1" />}
                    {b.due_date < todayIso ? "VENCIDA" : "PENDENTE"}
                  </span>
                )}
              </td>
              <td className="font-mono text-xs" data-testid={`bill-paid-date-${b.id}`}>
                {b.status === "paid" && b.paid_at ? (
                  <div>
                    <div className="font-bold text-[#00A300]">{new Date(b.paid_at + "T12:00:00").toLocaleDateString("pt-BR")}</div>
                    <div className="text-[10px] text-zinc-500 uppercase">via {METHOD_LABELS[b.paid_method] || b.paid_method || "—"}</div>
                  </div>
                ) : (
                  <span className="text-zinc-300">—</span>
                )}
              </td>
              <td className="text-right whitespace-nowrap">
                {b.status === "pending" ? (
                  <button className="text-xs underline mr-2 text-[#00A300]" onClick={() => onPay(b)} data-testid={`pay-${b.id}`}><CheckCircle size={12} className="inline mr-1" />Marcar Pago</button>
                ) : (
                  <button className="text-xs underline mr-2" onClick={() => onUnpay(b)} data-testid={`unpay-${b.id}`}><ArrowUUpLeft size={12} className="inline mr-1" />Reverter</button>
                )}
                <button className="text-xs underline mr-2" onClick={() => onEdit(b)}><PencilSimple size={12} className="inline mr-1" />Editar</button>
                <button className="text-xs underline text-red-600" onClick={() => onDelete(b)} data-testid={`remove-${b.id}`}><Trash size={12} className="inline mr-1" />Remover</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
